var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1884 35.7895C42.1884 39.7321 38.9921 42.9295 35.0473 42.9295C31.1037 42.9295 27.9073 39.7321 27.9073 35.7895C27.9073 31.8458 31.1037 28.6484 35.0473 28.6484C38.9921 28.6484 42.1884 31.8458 42.1884 35.7895Z",
    stroke: "#231D1D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4279 36.6554H35.264L35.0479 36.4382V32.5439",
    stroke: "#F25C54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3658 8.77246V16.666",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.751 8.77246V16.666",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02246 20.1036H37.7132",
    stroke: "#F25C54",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0948 28.5406V16.7621C38.0948 15.0553 36.7123 13.6738 35.0066 13.6738H12.1104C10.4047 13.6738 9.02216 15.0553 9.02216 16.7621V35.4315C9.02216 37.1382 10.4047 38.5197 12.1104 38.5197H27.5279",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6242 26.699C17.6242 27.4114 17.0457 27.9899 16.3344 27.9899C15.621 27.9899 15.0435 27.4114 15.0435 26.699C15.0435 25.9877 15.621 25.4092 16.3344 25.4092C17.0457 25.4092 17.6242 25.9877 17.6242 26.699Z",
    fill: "#231D1D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8487 26.699C24.8487 27.4114 24.2712 27.9899 23.5589 27.9899C22.8465 27.9899 22.268 27.4114 22.268 26.699C22.268 25.9877 22.8465 25.4092 23.5589 25.4092C24.2712 25.4092 24.8487 25.9877 24.8487 26.699Z",
    fill: "#231D1D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0731 26.699C32.0731 27.4114 31.4956 27.9899 30.7833 27.9899C30.0709 27.9899 29.4934 27.4114 29.4934 26.699C29.4934 25.9877 30.0709 25.4092 30.7833 25.4092C31.4956 25.4092 32.0731 25.9877 32.0731 26.699Z",
    fill: "#231D1D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6242 32.8914C17.6242 33.6038 17.0457 34.1823 16.3344 34.1823C15.621 34.1823 15.0435 33.6038 15.0435 32.8914C15.0435 32.1801 15.621 31.6016 16.3344 31.6016C17.0457 31.6016 17.6242 32.1801 17.6242 32.8914Z",
    fill: "#231D1D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8487 32.8914C24.8487 33.6038 24.2712 34.1823 23.5589 34.1823C22.8465 34.1823 22.268 33.6038 22.268 32.8914C22.268 32.1801 22.8465 31.6016 23.5589 31.6016C24.2712 31.6016 24.8487 32.1801 24.8487 32.8914Z",
    fill: "#231D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/Appointment.aee352d8c820b932d8361750c4acfc33.svg";
export { ForwardRef as ReactComponent };